import * as types from '../constantes/email';

export const SendEmailReducer = (state = {}, action) => {
  switch (action.type) {
    case types.SEND_EMAIL_REQUEST:
      return {
        loading: true,
      };

    case types.SEND_EMAIL_SUCESS:
      return {
        loading: false,
        success: true,
      };

    case types.SEND_EMAIL_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    case types.SEND_EMAIL_RESET:
      return {};

    default:
      return state;
  }
};
